import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { cloneDeep, get, isEqual, pick, map } from 'lodash';
import { IOrder, IOrderDetail, IOrderManagerConfig } from '@ispm-client/modules/orders/interfaces';
import { EventService } from '@ispm-client/modules/events/services/event.service';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OrderSFTPService } from '../../services/order.sftp.service';

@Directive()
export class OrderContentBaseComponent implements OnInit, OnDestroy {
  constructor(private changeDetector: ChangeDetectorRef,
              private _orderService: OrderSFTPService,
              private _eventService: EventService
  ) { }
    public load: boolean = true;
    public isFormValid: boolean = false;
    private _destroyer: Subject<any> = new Subject<any>();
    public _orderFormConfigs: Array<any>;
    public _orderFormData: any;
    public valid: boolean;
    public displayFooter: boolean;
    public selectedOrderDetailsArray: IOrderDetail[] = [];

    @Input() public hasUpdatedFields: boolean = false;
    @Input() selectedOrder: IOrder;
    @Input() config: IOrderManagerConfig;
    @Input() set selectedOrderDetails(orderDetails: IOrderDetail[]) {
        this.selectedOrderDetailsArray = orderDetails;
        this._orderFormConfigs = cloneDeep(this._orderFormConfigs);
    }
    @Input() set orderContentFormConfigs(_configs: Array<string>) {
        this.hasUpdatedFields = false;
        this._orderFormConfigs = cloneDeep(_configs);
    }
    @Input() public canEnablePartialSave: boolean = false;
    @Input() isEditable: boolean = false;
    @Input() watchPropertyForSaveButton: Array<string> = [];
    @Output() onFormDataUpdated: EventEmitter<any> = new EventEmitter();
    @Output() onFormDataSave: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.displayFooter = get(this.config, 'contentPanel.displayFooter', false);
        this.changeDetector.markForCheck();
        this.changeDetector.detectChanges();

        this._eventService.getIsDiscardEventTabData().pipe(takeUntil(this._destroyer.asObservable())).subscribe(isDiscardData => {
            if (this.hasUpdatedFields && isDiscardData) {
                this.hasUpdatedFields = !isDiscardData;
            }
        });
    }

    /**
    * Update form data
    * @param formData
    * @param index
    */
    updateFormData(formData: any, index?: number) {
        if (formData.form.form) { delete formData.form.form; }
        this._orderFormData = { ...formData };
        this.onFormDataUpdated.emit(this._orderFormData);
        this.checkIfContentUpdated();
    }

    private checkIfContentUpdated() {
        if (this._orderFormData && this._orderFormData.form) {
            this.canEnablePartialSave = true;
            const updatedOrderDetails = map(JSON.parse(
                JSON.stringify(get(this._orderFormData.form, get(this.config, 'contentPanel.extractData.path'), []))),
                (object) => pick(object, this.watchPropertyForSaveButton));
            const selectedOrderDetails = map(cloneDeep(this.selectedOrderDetailsArray), (object) => pick(object, this.watchPropertyForSaveButton));
            this.hasUpdatedFields = !((isEqual(selectedOrderDetails, updatedOrderDetails) || updatedOrderDetails === undefined)
                && isEqual(this.selectedOrder.dueDate, get(this._orderFormData, 'form.dueDate')));
        } else {
            this.hasUpdatedFields = false;
        }
    }

    /**
    * @method saveOrderContent
    */
    public saveOrderContent() {
        this.onFormDataSave.emit(this._orderFormData?.form);
    }

    public canUserWrite() {
        return this.displayFooter && get(this.selectedOrder, 'isActive', []).length > 0 ? false : this.isEditable;
    }

    public ngOnDestroy(): void {
        this._destroyer.next();
        this._destroyer.complete();
    }


}
